import React from 'react';
import { Link } from 'react-router-dom';

function Success() {
    return (
        <main className="bg-dark-300 min-h-screen flex items-center justify-center px-4">
            <div className="max-w-md w-full text-center">

                <div className="bg-dark-200 border border-gray-800 rounded-3xl p-10">
                    <div className="text-7xl mb-6">🎉</div>

                    <h1 className="font-display text-3xl font-bold text-white mb-4">
                        बधाई हो!
                    </h1>

                    <p className="text-gray-400 leading-relaxed mb-6">
                        आपका form successfully submit हो गया।
                        हमारे contractor <span className="text-saffron-500 font-semibold">48 घंटे</span> में
                        आपसे contact करेंगे।
                    </p>

                    <div className="bg-dark-300 border border-gray-800 rounded-2xl p-5 mb-8 text-left flex flex-col gap-3">
                        <div className="flex items-center gap-3">
                            <span className="text-saffron-500">✓</span>
                            <span className="text-gray-300 text-sm">Form submit ho gaya</span>
                        </div>
                        <div className="flex items-center gap-3">
                            <span className="text-saffron-500">✓</span>
                            <span className="text-gray-300 text-sm">Registration complete</span>
                        </div>
                        <div className="flex items-center gap-3">
                            <span className="text-yellow-500">⏳</span>
                            <span className="text-gray-300 text-sm">Contractor 48 ghante mein call karega</span>
                        </div>
                    </div>

                    <Link
                        to="/"
                        className="block bg-saffron-500 hover:bg-saffron-600 text-white font-semibold py-4 rounded-full transition shadow-lg shadow-saffron-500/30"
                    >
                        Home पर वापस जाओ
                    </Link>
                </div>

            </div>
        </main>
    );
}

export default Success;